import { render, staticRenderFns } from "./editAccountPassword.vue?vue&type=template&id=5dde4714&"
import script from "./editAccountPassword.vue?vue&type=script&lang=js&"
export * from "./editAccountPassword.vue?vue&type=script&lang=js&"
import style0 from "./editAccountPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editAccountPassword.vue"
export default component.exports